import { UserService } from '@/api/user';
import { useKeycloak } from '@react-keycloak/web';
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import { MenuConfig } from 'alurkerja-ui';
import { AccessType } from '@/utils/constants/users';

type MenuContextType = MenuConfig[] | null;

const MenuContext = createContext<MenuContextType>(null);

interface MenuProviderProps {
  children: ReactNode;
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
  const [menu, setMenu] = useState<MenuContextType>(null);
  const { initialized, keycloak } = useKeycloak();
  const isAuthenticated = initialized && keycloak.authenticated;
  const { data: user } = UserService.useGetProjectAssignees({
    enabled: isAuthenticated,
  });

  useEffect(() => {
    if (user) {
      const baseMenu: MenuConfig[] = [
        { href: '/user', label: 'Administrator' },
        { href: '/project', label: 'Project' },
        { href: '/worker', label: 'QC Workload' },
      ];

      // delete non admin menu
      if (user.user_type !== AccessType.ADMIN.toUpperCase()) {
        const adminMenus = ['/worker', '/user'];

        adminMenus.forEach(href => {
          const index = baseMenu.findIndex(menu => menu.href === href);

          if (index !== -1) {
            baseMenu.splice(index, 1);
          }
        });
      }

      setMenu(baseMenu);
    }
  }, [user]);
  return <MenuContext.Provider value={menu}>{children}</MenuContext.Provider>;
};

export const useMenu = (): MenuContextType => {
  return useContext(MenuContext);
};
